import Config from "../config";

export function isLogged(){
    return Config.getToken() ? true : false;
}

export function getLoggedInUser(){
    return Config.getUser();
}


// WEBPACK FOOTER //
// ./src/frontend/helpers/Helpers.js